// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicyPage_container__ab3KG","nestedUl":"PrivacyPolicyPage_nestedUl__jiVXr","nestedLi":"PrivacyPolicyPage_nestedLi__2M19x"};